const getProfileReducer = (state = { profileState: [], display: false }, action) => {
    switch (action.type) {
        case "GET_PROFILE":
            return {
                profileState: action.profileState,
                display: action.display
            }

        default:
            return state;
    }
}

export default getProfileReducer;


// WEBPACK FOOTER //
// ./src/reducer/getprofilereducer.jsx